import { store } from "reduxFiles/store";
import { responderApi } from "reduxFiles/api/responderApi";
import {
  setResponder,
  setResponderInitialized,
  setResponderLoading,
  clearResponderAuth,
} from "reduxFiles/slices/responderAuthSlice";

export const responderLoader = async () => {
  try {
    const token = sessionStorage.getItem("responder-token");

    store.dispatch(setResponderLoading(true));

    if (!token) {
      store.dispatch(setResponder(null));
      store.dispatch(setResponderInitialized(true));
      return;
    }

    const responder = await store
      .dispatch(
        responderApi.endpoints.getResponderProfile.initiate(undefined, {
          forceRefetch: true,
        })
      )
      .unwrap();

    store.dispatch(setResponder(responder));
  } catch (e) {
    store.dispatch(clearResponderAuth());
  } finally {
    store.dispatch(setResponderLoading(false));
    store.dispatch(setResponderInitialized(true));
  }
};
